import React from "react";

const ALEX_PHOTO =
  "/AlexAvatar.jpg";

export const AlexAvatar = ({ className = "h-9 w-9" }) => (
  <img
    src={ALEX_PHOTO}
    alt="Alex -assistant BIONET SOLUTIONS"
    loading="lazy"
    className={`${className} rounded-full object-cover`}
    onError={(e) => { e.currentTarget.style.visibility = "hidden"; }}
  />
);

export default AlexAvatar;
